import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { ThreeCanvas } from "@remotion/three";
import { SparkMesh } from "./KuroAndSpark3D";

export const SparkSoloShowcase: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, width, height } = useVideoConfig();

  return (
    <div
      style={{
        width,
        height,
        backgroundColor: "#070B0E",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            radial-gradient(circle at 50% 50%, rgba(255, 143, 0, 0.15) 0%, transparent 60%),
            linear-gradient(to bottom, rgba(20, 15, 10, 0.7), rgba(7, 11, 14, 0.98))
          `,
        }}
      />

      <div style={{ position: "absolute", inset: 0, zIndex: 10 }}>
        {/* Zoomed in camera centered on Spark */}
        <ThreeCanvas
          width={width}
          height={height}
          camera={{
            fov: 34,
            position: [0, 0.4, 4.4],
          }}
          shadows
        >
          <ambientLight intensity={1.1} color="#FFF1E0" />
          <directionalLight
            castShadow
            position={[4, 6, 4]}
            intensity={4.0}
            color="#FFF4E6"
            shadow-mapSize={[2048, 2048]}
          />
          <directionalLight position={[-4, 3, 3]} intensity={1.8} color="#FFD54F" />
          <directionalLight position={[4, 5, -4]} intensity={4.5} color="#FF8F00" />
          <directionalLight position={[-4, 5, -4]} intensity={2.5} color="#80DEEA" />
          <pointLight position={[0, 0.5, 1.8]} intensity={1.8} color="#FFA000" distance={4} />

          {/* Stage floor & glowing amber ring */}
          <group position={[0, -0.85, 0]}>
            <mesh receiveShadow position={[0, 0, 0]}>
              <cylinderGeometry args={[2.0, 2.0, 0.12, 48]} />
              <meshStandardMaterial color="#161F26" roughness={0.7} metalness={0.1} />
            </mesh>
            <mesh position={[0, 0.065, 0]} rotation={[-Math.PI / 2, 0, 0]}>
              <ringGeometry args={[0.95, 1.02, 36]} />
              <meshBasicMaterial color="#FF9100" />
            </mesh>
          </group>

          {/* Spark Centered, Lowered into View */}
          <group position={[0, -0.9, 0]} rotation={[0, -0.2, 0]} scale={[1.2, 1.2, 1.2]}>
            <SparkMesh frame={frame} fps={fps} isSpeaking={true} isSurprised={false} />
          </group>
        </ThreeCanvas>
      </div>

      {/* Clean Tag */}
      <div
        style={{
          position: "absolute",
          top: 220,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 50,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(255, 143, 0, 0.15)",
            border: "1px solid rgba(255, 143, 0, 0.4)",
            padding: "8px 24px",
            borderRadius: 999,
            color: "#FFA000",
            fontSize: 16,
            fontWeight: 800,
            letterSpacing: 2,
            textTransform: "uppercase",
            boxShadow: "0 0 25px rgba(255, 143, 0, 0.3)",
          }}
        >
          💡 SPARK • VACUUM DROID (CLOSE-UP)
        </div>
      </div>
    </div>
  );
};
